module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }